'use client';

import {styled, type SxProps, type Theme} from '@mui/material/styles';
import type React from 'react';

export type SectionTone = 'base' | 'subtle' | 'raised' | 'inverse';

export interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  tone?: SectionTone;
  sx?: SxProps<Theme>;
  children: React.ReactNode;
}

const Root = styled('section', {
  shouldForwardProp: propName => propName !== 'oTone',
})<{oTone: SectionTone}>(({theme, oTone}) => ({
  width: '100%',

  ...{
    base: {backgroundColor: theme.palette.colors.surface.neutral.page, color: theme.palette.colors.text.neutral.default},
    subtle: {backgroundColor: theme.palette.colors.surface.neutral.pageAlternative, color: theme.palette.colors.text.neutral.default},
    raised: {backgroundColor: theme.palette.colors.surface.neutral.default, color: theme.palette.colors.text.neutral.default},
    inverse: {backgroundColor: theme.palette.colors.surface.neutral.inverse, color: theme.palette.colors.text.neutral.inverse},
  }[oTone],

  paddingBlock: theme.spacing(4),
  [theme.breakpoints.up('md')]: {paddingBlock: theme.spacing(6)},
}));

export function Section({tone = 'base', sx, children, ...rest}: SectionProps) {
  return (
    <Root oTone={tone} sx={sx} {...rest}>
      {children}
    </Root>
  );
}

Section.displayName = 'Section';
